module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head full-width"
  }, [_c('h3', [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v("\r\n          " + _vm._s(_vm.prefix) + "\r\n          "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  }), _vm._v(" "), (_vm.prefix == 'vorige') ? _c('small', [_vm._v("In dit overzicht worden reizen getoond vanaf 1-1-2017")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-suitcase pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1)]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', [(_vm.reservations.length < 1) ? _c('div', [_c('p', {
    staticStyle: {
      "padding-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\r\n            Geen " + _vm._s(_vm.prefix) + " "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1)]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_c('div', {
      staticClass: "card-head"
    }, [_c('h3', [_vm._v(_vm._s(reservation.travel_package_name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-row"
    }, [_c('div', {
      staticClass: "card-column"
    }, [_c('p', {
      staticClass: "title-text"
    }, [_c('entity-text', {
      attrs: {
        "text": "destination"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.travel_package_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.start_date))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.end_date))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.days) + " dagen")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.reservation_number))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('router-link', {
      staticClass: "md-btn pull-right",
      attrs: {
        "tag": "button",
        "to": {
          name: 'reservation',
          params: {
            reservationId: reservation.id
          }
        }
      }
    }, [_vm._v("\r\n                  Meer info\r\n                ")])], 1)])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Vertrekdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Terugkomstdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Aantal dagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Reserveringsnummer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53b85ce6"}!./src/templates/reservations/reservation-list.html
// module id = 539
// module chunks = 1